import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import {environment} from '../../../environments/environment';
// import { AngularFirestore } from '@angular/fire/firestore';
 import { AngularFireStorage } from '@angular/fire/storage';
// import * as firebase from 'firebase/app';
import { CommonService, AdminService } from '../../_services/';
import { map, finalize } from "rxjs/operators";
import { Observable } from "rxjs";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-file-dialog',
  templateUrl: './add-file-dialog.component.html',
  styleUrls: ['./add-file-dialog.component.scss']
})
export class AddFileDialogComponent implements OnInit {
  uploadForm:FormGroup;
  imageURL:String;
  selectedFile:File;
  ref:any;
  fb:any;
  // task:any;
  // uploadProgress:any;
  downloadURL: Observable<string>;
  constructor(
    public dialogRef: MatDialogRef<AddFileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private afStorage: AngularFireStorage,
    private _common : CommonService,
    private _admin : AdminService,
    private _toastr : ToastrService
  ) {
    this.selectedFile = data.img;
   }

  ngOnInit() { alert();
    this.uploadForm = this.formBuilder.group({
      file: [null, [Validators.required]]
    })
    this.showPreview(this.selectedFile)
  }


  hideAddFileDialog() {
    this.dialogRef.close();
  }

   // Image Preview
 showPreview(file) {
  // const file = (event.target as HTMLInputElement).files[0];
  // this.uploadForm.patchValue({
  //   file: file
  // });
  // this.selectedFile = event.target.files[0];
  if(file.type==="image/png" || file.type==="image/jpeg" || file.type==="image/jpg"){
    this.uploadForm.get('file').updateValueAndValidity()

    // File Preview
    const reader = new FileReader();
    reader.onload = () => {
      this.imageURL = reader.result as string;
    }
    reader.readAsDataURL(file)
  
  }
  else {
    this.imageURL = './assets/images/file-placeholder.jpg';
  }
}

// Submit Form
onFormSubmit() {
  this._common.showLoader(true);
  
  const uid = localStorage.getItem('uid');
  const randomId = Math.random().toString(36).substring(2);
  this.ref = this.afStorage.ref(`${uid}/${randomId}-${this.selectedFile.name}`);
  const task = this.afStorage.upload(`${uid}/${randomId}-${this.selectedFile.name}`,this.selectedFile);
  
  task.snapshotChanges().pipe(
    finalize(() => {
      this.downloadURL = this.ref.getDownloadURL();
      this.downloadURL.subscribe(url => {
        if (url) {
          let data ={
            uid : localStorage.getItem('uid'),
            filepath : url
          }
          
          this._admin.addFile(data).subscribe(res => {
            if(res){
              this._common.showLoader(false);
              this.dialogRef.close();  
              this._toastr.success(`File successfully uploaded!`,"",{ timeOut: 4000 });
            }
          },err=>{
            this._common.showLoader(false);
            this.dialogRef.close();  
            this._toastr.error(`File uploading failed!`,"",{ timeOut: 4000 });
          }) 
          // this.fb = url;
        }
      });
    })
  ).subscribe(url => {})
}

// onFormSubmit(){
//   const selectdFile = this.selectedFile;
//   return new Promise(function(resolve, reject) {
//     var fire = firebase.initializeApp(environment.firebaseConfig);
//     const uid = localStorage.getItem('uid');
//     var storageRef = firebase.storage().ref(`${Math.random().toString(36).substring(2)}-${selectdFile.name}`);
//     var task = storageRef.put(selectdFile);
    
//     task.on('state_changed', function complete() {
//       task.snapshot.ref.getDownloadURL().then(function (downloadURL) {
//         // return downloadURL;
//         resolve(downloadURL);
//       });
//     });
//   });

// }

}
